import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import userManagementReducer from './slices/userManagementSlice';
import orderManagementReducer from './slices/orderManagementSlice';
import inventoryReducer from './slices/inventorySlice';
import stockApprovalReducer from './slices/stockApprovalSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    userManagement: userManagementReducer,
    orderManagement: orderManagementReducer,
    inventory: inventoryReducer,
    stockApproval: stockApprovalReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
